import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import { properties } from 'src/environments/properties';

declare let $: any;
@Component({
  selector: 'app-partners-faq',
  templateUrl: './partners-faq.component.html',
  styleUrls: ['./partners-faq.component.scss']
})
export class PartnersFaqComponent implements OnInit, AfterViewInit {
  @Input() faqData;
  showFAQ =  false;
  properties = properties;

  ngAfterViewInit(): void {
    this.initAccordianHeader()
  }

  ngOnInit(): void {
    if (this.faqData && this.faqData.length > 0) {
      this.showFAQ = true;
    }
  }
  
  initAccordianHeader() {
      $('.faq-accordion-header').toggleClass('inactive-header');
      $('.display-type').each(function () {
          let displayType = $(this).attr("data-display-type");
          if (displayType == 'expandFirst') {
              $(this).find('.faq-accordion-header').first().toggleClass('active-header').toggleClass('inactive-header');
              $(this).find('.faq-accordian-content').first().slideDown().toggleClass('open-content');
          } else if (displayType == 'expanded') {
              $(this).find('.faq-accordion-header').toggleClass('active-header').toggleClass('inactive-header');
              $(this).find('.faq-accordian-content').slideDown().toggleClass('open-content');
          }
      });

      // The Accordion Effect
      $(".faq-accordion-header").each(function () {
          if ($(this).hasClass('active-header')) {
              $('.faq-accordion-header').attr('aria-expanded', 'true');
          } else {
              $(this).attr('aria-expanded', 'false');
          }
      });

      $('.faq-accordion-header').click(function () {
          if ($(this).is('.inactive-header')) {
              $(this).toggleClass('active-header').toggleClass('inactive-header');
              $(this).attr('aria-expanded', 'true');
              $(this).next().slideToggle().toggleClass('open-content');

          } else {
              $(this).toggleClass('active-header').toggleClass('inactive-header');
              $(this).attr('aria-expanded', 'false');
              $(this).next().slideToggle().toggleClass('open-content');
          }
      });

      $('.faq-accordion-header').keypress(function (e) {
          let key = e.which;
          if (key == 13) {
              if ($(this).is('.inactive-header')) {
                  $(this).toggleClass('active-header').toggleClass('inactive-header');
                  $(this).attr('aria-expanded', 'true');
                  $(this).next().slideToggle().toggleClass('open-content');
              } else {
                  $(this).toggleClass('active-header').toggleClass('inactive-header');
                  $(this).attr('aria-expanded', 'false');
                  $(this).next().slideToggle().toggleClass('open-content');
              }
          }
      });
  }

}
